import React from 'react'
import { Box, Grid, Typography } from '@mui/material'

import {useTheme} from '@mui/material';
import { tokens } from '../../theme';
import {
    SiVisualstudiocode,
    SiPostman,
   
  } from "react-icons/si";
  import { SiMicrosoftsqlserver } from "react-icons/si";
  import { SiVisualstudio } from "react-icons/si";

import { LuFigma } from "react-icons/lu";

const Tool = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
    <Box>
    <Grid container spacing={2}>
        <Grid xs={12}>
            <Box display='flex' flexDirection='row' justifyContent='center' marginTop={10}>
                <Typography variant='h2' fontWeight='bold'>TOOLS I <strong className="main-name" style={{ color: colors.blueAccent[400] }}>USE</strong></Typography>
            </Box>
            
            <Box display='flex' marginTop={10} marginLeft={10} marginRight={10}>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiVisualstudio ></SiVisualstudio>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiVisualstudiocode></SiVisualstudiocode>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiMicrosoftsqlserver></SiMicrosoftsqlserver>
                      </Grid>
                      
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <SiPostman></SiPostman>
                      </Grid>
                      <Grid xs={2} display='flex' justifyContent='center' className="tech-icons">
                          <LuFigma></LuFigma>
                      </Grid>
                </Box>
           
        </Grid>
    </Grid>
</Box>
  )
}

export default Tool